import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Globals } from './globals';
import { ToastService } from './toasts/toast.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router, private toast: ToastService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers: any = {
            Accept: 'application/json',
            // 'Content-Type': 'application/json',
            locale: 'en',
            'request-platform': 'android'
        };
        const token = Globals.getToken();
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        if (req.url.startsWith(environment.automationBaseUrl)) {
            headers['X-API-Key'] = environment.apiKey;
        }
        const authReq = req.clone({
            setHeaders: headers
        });
        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    Globals.clearLocalStorage();
                    this.router.navigate(['/']);
                    this.toast.error("Session Expired! or Unauthorized User.");
                }
                return throwError(() => error);
            })
        );
    }
}